export const Links = {
  downloadAppAndroid: 'https://storage.googleapis.com/liquid-bucket-mobile/Liquid.apk',
  downloadAppIOS: 'https://apps.apple.com/ru/app/liquid-mining/id6447574571',
  Twitter: 'https://twitter.com/liquid__mining',
  Discord: 'https://discord.com/invite/nftliquid',
  Telegram: 'https://t.me/nftliquid',
  YouTube: 'https://www.youtube.com/@liquidminingofficial',
  mailTo: 'mailto:support@liquidmining.com',
};
